module.exports = __webpack_public_path__ + "static/17-662bddb5f24ca80e8dbe2f4117abb1b0.png";